import React from 'react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { ArrowRight, Zap, Brain, Code, Database, Users, Globe, TrendingUp, CheckCircle, Star, MapPin, Calendar } from 'lucide-react';
import Navigation from './Navigation';
import tulioIcon from './assets/tulio.png'
import { Link, useNavigate } from "react-router-dom";
// import CaseStudies from './CaseStudies';
// import TeamSection from './TeamSection';
// import ClientSection from './ClientSection';
// import ContactSection from './ContactSection';

const TulioLanding = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white">
    {/* Header */}
      <header className="border-b border-slate-200 bg-white/80 backdrop-blur-md sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
             <Link to="/" className="flex items-center space-x-3">
            <img 
  src={tulioIcon} 
  alt="Tulio Labs" 
  className="h-12 w-auto" 
/>

            </Link>
            
            <Navigation />
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-slate-800 to-emerald-900"></div>
        <div className="absolute inset-0 opacity-20">
          <div className="w-full h-full" style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
          }}></div>
        </div>
        
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 lg:py-32">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="flex items-center space-x-2 mb-6">
                <MapPin className="w-4 h-4 text-emerald-400" />
                <span className="text-emerald-400 text-sm font-medium">Singapore • Global Engineering Centers</span>
              </div>
              
              <h1 className="text-4xl lg:text-6xl font-bold text-white mb-6">
                Building the
                <span className="block text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-teal-400 animate-pulse">
                  Future of Tech
                </span>
              </h1>
              
              <p className="text-xl text-slate-300 mb-8 leading-relaxed">
                We partner with ambitious organizations to design, build, and scale next-generation products powered by AI. From MVP to enterprise scale.
              </p>
              
              <div className="flex flex-col sm:flex-row gap-4 mb-8">
                <Button 
                  size="lg" 
                  className="bg-emerald-600 hover:bg-emerald-700 text-lg px-8 py-4"
                  onClick={() => window.open('https://calendly.com/admin-tuliolabs/30min', '_blank')}
                >
                  <Calendar className="w-5 h-5 mr-2" />
                  Book a Strategy Call
                </Button>
                
                <Link to="/case-studies">
  <Button
    size="lg"
    variant="outline"
    className="border-slate-400 text-white hover:bg-white/10 text-lg px-8 py-4"
  >
    View Our Work
    <ArrowRight className="w-5 h-5 ml-2" />
  </Button>
</Link>
              </div>
              
              <div className="flex items-center space-x-6 text-slate-400">
                <div className="flex items-center space-x-2">
                  <CheckCircle className="w-4 h-4 text-emerald-400" />
                  <span className="text-sm">150+ Projects Delivered</span>
                </div>
                <div className="flex items-center space-x-2">
                  <CheckCircle className="w-4 h-4 text-emerald-400" />
                  <span className="text-sm">100+ Engineers</span>
                </div>
              </div>
            </div>
            
            <div className="relative">
              <div className="grid grid-cols-2 gap-4">
                <div className="space-y-4">
               <div onClick={()=>{
                navigate('/services/ai-consulting')
               }} className="bg-white/10 backdrop-blur-md border border-white/20 rounded-xl p-6 transform rotate-3 hover:rotate-0 transition-transform duration-300 cursor-pointer">
                    <Brain className="w-8 h-8 text-emerald-400 mb-3" />
                    <h3 className="text-white font-semibold mb-2">AI Integration</h3>
                    <p className="text-slate-300 text-sm">Custom AI agents and workflow automation</p>
                  </div>
                 
                <div onClick={()=>{
                  navigate("/services/full-product-development" )
                }} className="bg-white/10 backdrop-blur-md border border-white/20 rounded-xl p-6 transform -rotate-2 hover:rotate-0 transition-transform duration-300 cursor-pointer">
                    <Code className="w-8 h-8 text-teal-400 mb-3" />
                    <h3 className="text-white font-semibold mb-2">Full Stack Development</h3>
                    <p className="text-slate-300 text-sm">End-to-end product development</p>
                  </div>
                </div>
                <div className="space-y-4 mt-8">
             <div onClick={()=>{
              navigate("/services/data-engineering")
             }} className="bg-white/10 backdrop-blur-md border border-white/20 rounded-xl p-6 transform rotate-1 hover:rotate-0 transition-transform duration-300 cursor-pointer">
                    <Database className="w-8 h-8 text-cyan-400 mb-3" />
                    <h3 className="text-white font-semibold mb-2">Data Engineering</h3>
                    <p className="text-slate-300 text-sm">Analytics, ML, and data pipelines</p>
                  </div> 
                <div onClick={()=>{
                  navigate("/services/growth-support")
                }} className="bg-white/10 backdrop-blur-md border border-white/20 rounded-xl p-6 transform -rotate-1 hover:rotate-0 transition-transform duration-300 cursor-pointer">
                    <Globe className="w-8 h-8 text-emerald-400 mb-3" />
                    <h3 className="text-white font-semibold mb-2">Global Scale</h3>
                    <p className="text-slate-300 text-sm">Cross-border engineering excellence</p>
                  </div> 
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <Badge className="mb-4 bg-emerald-100 text-emerald-700 hover:bg-emerald-100">Our Services</Badge>
            <h2 className="text-4xl font-bold text-slate-900 mb-4">
              Comprehensive Technology Solutions
            </h2>
            <p className="text-xl text-slate-600 max-w-3xl mx-auto">
              From AI-powered products to enterprise transformations, we deliver end-to-end technology solutions that drive business growth.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Service Cards */}
           <Link to="/services/full-product-development"> <Card className="group hover:shadow-xl transition-all duration-300 border-slate-200 hover:border-emerald-200"> 
              <CardContent className="p-8">
                <div className="w-12 h-12 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                  <Code className="w-6 h-6 text-white" />
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-4">Full Product Development</h3>
                <p className="text-slate-600 mb-6">End-to-end product development from vision to reality. We handle design, engineering, deployment, and scaling.</p>
                <ul className="space-y-2">
                  <li className="flex items-center text-sm text-slate-600">
                    <CheckCircle className="w-4 h-4 text-emerald-500 mr-2" />
                    Vision & Planning
                  </li>
                  <li className="flex items-center text-sm text-slate-600">
                    <CheckCircle className="w-4 h-4 text-emerald-500 mr-2" />
                    Design & UX/UI
                  </li>
                  <li className="flex items-center text-sm text-slate-600">
                    <CheckCircle className="w-4 h-4 text-emerald-500 mr-2" />
                    Engineering & Deployment
                  </li>
                </ul>
              </CardContent>
            </Card> </Link>

            <Link to="/services/ai-consulting"> <Card className="group hover:shadow-xl transition-all duration-300 border-slate-200 hover:border-emerald-200">
              <CardContent className="p-8">
                <div className="w-12 h-12 bg-gradient-to-br from-cyan-500 to-blue-600 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                  <Brain className="w-6 h-6 text-white" />
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-4">AI Consulting & Agent Development</h3>
                <p className="text-slate-600 mb-6">Transform your business with intelligent automation, custom AI agents, and workflow optimization.</p>
                <ul className="space-y-2">
                  <li className="flex items-center text-sm text-slate-600">
                    <CheckCircle className="w-4 h-4 text-emerald-500 mr-2" />
                    Workflow AI Integration
                  </li>
                  <li className="flex items-center text-sm text-slate-600">
                    <CheckCircle className="w-4 h-4 text-emerald-500 mr-2" />
                    Custom AI Agents
                  </li>
                  <li className="flex items-center text-sm text-slate-600">
                    <CheckCircle className="w-4 h-4 text-emerald-500 mr-2" />
                    Legacy System Enhancement
                  </li>
                </ul>
              </CardContent>
            </Card> </Link>

          <Link to="/services/technology-consulting">  <Card className="group hover:shadow-xl transition-all duration-300 border-slate-200 hover:border-emerald-200">
              <CardContent className="p-8">
                <div className="w-12 h-12 bg-gradient-to-br from-orange-500 to-red-600 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                  <Zap className="w-6 h-6 text-white" />
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-4">Technology Consulting</h3>
                <p className="text-slate-600 mb-6">Solve complex technical challenges with architectural guidance, system integrations, and performance optimization.</p>
                <ul className="space-y-2">
                  <li className="flex items-center text-sm text-slate-600">
                    <CheckCircle className="w-4 h-4 text-emerald-500 mr-2" />
                    Stack Evaluation & Reengineering
                  </li>
                  <li className="flex items-center text-sm text-slate-600">
                    <CheckCircle className="w-4 h-4 text-emerald-500 mr-2" />
                    System Integrations
                  </li>
                  <li className="flex items-center text-sm text-slate-600">
                    <CheckCircle className="w-4 h-4 text-emerald-500 mr-2" />
                    Performance & Security
                  </li>
                </ul>
              </CardContent>
            </Card> </Link>

           <Link to="/services/staff-augmentation"> <Card className="group hover:shadow-xl transition-all duration-300 border-slate-200 hover:border-emerald-200">
              <CardContent className="p-8">
                <div className="w-12 h-12 bg-gradient-to-br from-violet-500 to-purple-600 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                  <Users className="w-6 h-6 text-white" />
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-4">Staff Augmentation</h3>
                <p className="text-slate-600 mb-6">Scale your team with our global engineering talent. Flexible capacity with seamless integration.</p>
                <ul className="space-y-2">
                  <li className="flex items-center text-sm text-slate-600">
                    <CheckCircle className="w-4 h-4 text-emerald-500 mr-2" />
                    Remote & Onsite Engineers
                  </li>
                  <li className="flex items-center text-sm text-slate-600">
                    <CheckCircle className="w-4 h-4 text-emerald-500 mr-2" />
                    Flexible Scaling
                  </li>
                  <li className="flex items-center text-sm text-slate-600">
                    <CheckCircle className="w-4 h-4 text-emerald-500 mr-2" />
                    Cost Advantages
                  </li>
                </ul>
              </CardContent>
            </Card> </Link>

           <Link to="/services/data-engineering"> <Card className="group hover:shadow-xl transition-all duration-300 border-slate-200 hover:border-emerald-200">
              <CardContent className="p-8">
                <div className="w-12 h-12 bg-gradient-to-br from-teal-500 to-green-600 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                  <Database className="w-6 h-6 text-white" />
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-4">Data Engineering & ML</h3>
                <p className="text-slate-600 mb-6">Transform data into actionable insights with advanced analytics, ML models, and data platforms.</p>
                <ul className="space-y-2">
                  <li className="flex items-center text-sm text-slate-600">
                    <CheckCircle className="w-4 h-4 text-emerald-500 mr-2" />
                    ETL Pipelines & Data Lakes
                  </li>
                  <li className="flex items-center text-sm text-slate-600">
                    <CheckCircle className="w-4 h-4 text-emerald-500 mr-2" />
                    Analytics Dashboards
                  </li>
                  <li className="flex items-center text-sm text-slate-600">
                    <CheckCircle className="w-4 h-4 text-emerald-500 mr-2" />
                    ML Model Deployment
                  </li>
                </ul>
              </CardContent>
            </Card> </Link>

          <Link to="/services/growth-support">  <Card className="group hover:shadow-xl transition-all duration-300 border-slate-200 hover:border-emerald-200">
              <CardContent className="p-8">
                <div className="w-12 h-12 bg-gradient-to-br from-indigo-500 to-blue-600 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                  <TrendingUp className="w-6 h-6 text-white" />
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-4">Growth & Capital Support</h3>
                <p className="text-slate-600 mb-6">Beyond technology - helping with grants, financing, fundraising, and strategic growth initiatives.</p>
                <ul className="space-y-2">
                  <li className="flex items-center text-sm text-slate-600">
                    <CheckCircle className="w-4 h-4 text-emerald-500 mr-2" />
                    Grant Consulting
                  </li>
                  <li className="flex items-center text-sm text-slate-600">
                    <CheckCircle className="w-4 h-4 text-emerald-500 mr-2" />
                    Fundraising Support
                  </li>
                  <li className="flex items-center text-sm text-slate-600">
                    <CheckCircle className="w-4 h-4 text-emerald-500 mr-2" />
                    Strategic Partnerships
                  </li>
                </ul>
              </CardContent>
            </Card> </Link>
          </div>
        </div>
      </section>

      {/* Case Studies Section */}
      {/* <CaseStudies /> */}

      {/* Team Section */}
      {/* <TeamSection /> */}

      {/* Client Section */}
      {/* <ClientSection /> */}

      {/* Contact Section */}
      {/* <ContactSection /> */}

      {/* Footer */}
      <footer className="bg-slate-900 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
            <div className="md:col-span-2">
              <div className="flex items-center space-x-3 mb-4">
                     <img 
  src={tulioIcon} 
  alt="Tulio Labs" 
  className="h-12 w-auto" 
/>
              </div>
              <p className="text-slate-400 mb-6 max-w-md">
                Empowering organizations with innovative, scalable, and outcome-driven technology solutions across AI, product development, and digital transformation.
              </p>
              <div className="flex space-x-4">
                <Badge className="bg-emerald-600 hover:bg-emerald-700">Singapore HQ</Badge>
                <Badge className="bg-teal-600 hover:bg-teal-700">Global Engineering</Badge>
              </div>
            </div>
            
            <div>
              <h4 className="font-semibold mb-4">Services</h4>
              <ul className="space-y-2 text-slate-400">
              <li>
  <Link
    to="/services/full-product-development"
    className="hover:text-emerald-400 transition-colors"
  >
    Product Development
  </Link>
</li>
                <li> <Link
    to="/services/ai-consulting"
    className="hover:text-emerald-400 transition-colors"
  >AI Consulting  </Link></li>
                <li> <Link
    to="/services/data-engineering"
    className="hover:text-emerald-400 transition-colors">Data Engineering</Link></li>
                <li> <Link
    to="/services/staff-augmentation"
    className="hover:text-emerald-400 transition-colors">Staff Augmentation</Link></li>
              </ul>
            </div>
            
            <div>
              <h4 className="font-semibold mb-4">Company</h4>
              <ul className="space-y-2 text-slate-400">
                <li><a href="#about" className="hover:text-emerald-400 transition-colors">About Us</a></li>
                <li><a href="#team" className="hover:text-emerald-400 transition-colors">Team</a></li>
                <li>
  <Link to="/case-studies" className="hover:text-emerald-400 transition-colors">
    Case Studies
  </Link>
</li>
                <li>
  <Link 
    to="/ContactSection" 
    className="hover:text-emerald-400 transition-colors"
  >
    Contact
  </Link>
</li>

              </ul>
            </div>
          </div>
          
          <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center">
            <p className="text-slate-400 text-sm">© 2025 Tulio Labs Pte Ltd. All rights reserved.</p>
            <div className="flex items-center space-x-2 mt-4 md:mt-0">
              <MapPin className="w-4 h-4 text-emerald-400" />
              <span className="text-slate-400 text-sm">Singapore • India • Vietnam • Philippines</span>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default TulioLanding;